/** index.html의 HUD DOM 요소 접근을 한곳에서 타입 안전하게 처리한다. */
export interface HUDElements {
  /** 클릭 시 pointer-lock으로 진입하는 풀스크린 오버레이. */
  enterOverlay: HTMLElement;
  /** VR 입장/종료 버튼. */
  vrButton: HTMLButtonElement;
}

export function getHUD(): HUDElements {
  const enterOverlay = document.getElementById('enter');
  const vrButton = document.getElementById('vr');

  if (!enterOverlay || !(vrButton instanceof HTMLButtonElement)) {
    throw new Error('HUD 요소를 찾을 수 없음 (index.html의 #enter / #vr 확인).');
  }

  return { enterOverlay, vrButton };
}
